import { AppTheme } from "../../theme";

export const createProductiveUnitInfoPageStyle = (theme: AppTheme) => {
    return {
        main: {
            flexGrow: 1,
            height: {
                xs: 'calc(100vh)',
            },
            overflow: 'auto',
            backgroundColor: theme.palette.layoutBackground,
        },
        card: {
            maxWidth: "1280px",
            backgroundColor: "white",
            boxShadow: "0px 4px 4px 0px #00000040",
            borderRadius: "4px",
            p: {
                xs: "20px 16px 20px 16px",
                md: "45px 70px 20px 70px"
            },
            mt: "80px",
            mb: "80px",
            display: "flex",
            ml: {
                xs: "20px",
                md: "auto"
            },
            mr: {
                xs: "20px",
                md: "auto"
            },
            minHeight: "calc(100vh - 200px)",
            position: "relative"
        },
        logoWrapper: {
            display: {
                xs: 'none',
                md: 'flex'
            },
            justifyContent: 'flex-end',
            mb: "24px"
        },
        logoWrapperMobile: {
            display: {
                xs: 'flex',
                md: 'none'
            },
            justifyContent: 'center',
            mb: "24px"
        },
        logo: {
            // m: '24px auto 0 auto',
            height: '76.65px',
            width:'100%',
            maxWidth:164,
            backgroundImage: `url(/assets/images/${theme.applogo})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "contain",
        },
        mapWrapper: {
            height: "260px",
            overflow: "hidden",
            borderRadius: {
                xs: "16px",
                md: "8px"
            },
            p: {
                xs: "10px",
                md: 0
            },
            border: {
                xs: `1px solid ${theme.palette.neutral_4}`,
                md: "none"
            },
            boxShadow: {
                xs: " 0px 2px 4px 0px #00000029",
                md: "none"
            }
        },
        detailCard:{
            borderRadius:"14px",
            backgroundColor: theme.palette.neutral_4,
            p: {
                xs:"16px 20px",
                md:"36px 40px"
            }
        },
    }
}
